export default ({axios}) => ({
    requestLogs: (body = {}) => axios.get(`/_debug/requests`, body),
})
